import { Button, rem } from "@mantine/core";

import { IconDownload } from "@tabler/icons-react";

import { EXPORT_CSV_ICON_SIZE, EXPORT_CSV_LABEL } from "./constants/practice-ledger";
import type { PracticeLedgerCsvExportButtonProps } from "./types/ledger-ui";

export default function LedgerCsvExportButton({
  isExporting,
  onExport,
}: PracticeLedgerCsvExportButtonProps) {
  return (
    <Button
      variant="outline"
      onClick={onExport}
      loading={isExporting}
      disabled={isExporting}
      data-testid="practice-ledger-export-csv"
      leftSection={
        <IconDownload
          style={{ width: rem(EXPORT_CSV_ICON_SIZE), height: rem(EXPORT_CSV_ICON_SIZE) }}
        />
      }
    >
      {EXPORT_CSV_LABEL}
    </Button>
  );
}
